module.exports = __webpack_public_path__ + "img/1170.7f8004fd.gif";